$(document).ready(function(){

    var nuevoDiv = $(`<div class="img_tarjetas container--large"><div class="section-footer__payment-icons">



            
            
          
              <svg class="section-footer__payment-icon" viewBox="0 0 38 24" xmlns="http://www.w3.org/2000/svg" role="img" width="38" height="24" aria-labelledby="pi-visa"><title id="pi-visa">Visa</title><path opacity=".07" d="M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z"></path><path fill="#fff" d="M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32"></path><path d="M28.3 10.1H28c-.4 1-.7 1.5-1 3h1.9c-.3-1.5-.3-2.2-.6-3zm2.9 5.9h-1.7c-.1 0-.1 0-.2-.1l-.2-.9-.1-.2h-2.4c-.1 0-.2 0-.2.2l-.3.9c0 .1-.1.1-.1.1h-2.1l.2-.5L27 8.7c0-.5.3-.7.8-.7h1.5c.1 0 .2 0 .2.2l1.4 6.5c.1.4.2.7.2 1.1.1.1.1.1.1.2zm-13.4-.3l.4-1.8c.1 0 .2.1.2.1.7.3 1.4.5 2.1.4.2 0 .5-.1.7-.2.5-.2.5-.7.1-1.1-.2-.2-.5-.3-.8-.5-.4-.2-.8-.4-1.1-.7-1.2-1-.8-2.4-.1-3.1.6-.4.9-.8 1.7-.8 1.2 0 2.5 0 3.1.2h.1c-.1.6-.2 1.1-.4 1.7-.5-.2-1-.4-1.5-.4-.3 0-.6 0-.9.1-.2 0-.3.1-.4.2-.2.2-.2.5 0 .7l.5.4c.4.2.8.4 1.1.6.5.3 1 .8 1.1 1.4.2.9-.1 1.7-.9 2.3-.5.4-.7.6-1.4.6-1.4 0-2.5.1-3.4-.2-.1.2-.1.2-.2.1zm-3.5.3c.1-.7.1-.7.2-1 .5-2.2 1-4.5 1.4-6.7.1-.2.1-.3.3-.3H18c-.2 1.2-.4 2.1-.7 3.2-.3 1.5-.6 3-1 4.5 0 .2-.1.2-.3.2M5 8.2c0-.1.2-.2.3-.2h3.4c.5 0 .9.3 1 .8l.9 4.4c0 .1 0 .1.1.2 0-.1.1-.1.1-.1l2.1-5.1c-.1-.1 0-.2.1-.2h2.1c0 .1 0 .1-.1.2l-3.1 7.3c-.1.2-.1.3-.2.4-.1.1-.3 0-.5 0H9.7c-.1 0-.2 0-.2-.2L7.9 9.5c-.2-.2-.5-.5-.9-.6-.6-.3-1.7-.5-1.9-.5L5 8.2z" fill="#142688"></path></svg>
            
              <svg class="section-footer__payment-icon" viewBox="0 0 38 24" xmlns="http://www.w3.org/2000/svg" role="img" width="38" height="24" aria-labelledby="pi-master"><title id="pi-master">Mastercard</title><path opacity=".07" d="M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z"></path><path fill="#fff" d="M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32"></path><circle fill="#EB001B" cx="15" cy="12" r="7"></circle><circle fill="#F79E1B" cx="23" cy="12" r="7"></circle><path fill="#FF5F00" d="M22 12c0-2.4-1.2-4.5-3-5.7-1.8 1.3-3 3.4-3 5.7s1.2 4.5 3 5.7c1.8-1.2 3-3.3 3-5.7z"></path></svg>
            
              <svg class="section-footer__payment-icon" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 38 24" width="38" height="24" aria-labelledby="pi-american_express"><title id="pi-american_express">American Express</title><g fill="none"><path fill="#000" d="M35,0 L3,0 C1.3,0 0,1.3 0,3 L0,21 C0,22.7 1.4,24 3,24 L35,24 C36.7,24 38,22.7 38,21 L38,3 C38,1.3 36.6,0 35,0 Z" opacity=".07"></path><path fill="#006FCF" d="M35,1 C36.1,1 37,1.9 37,3 L37,21 C37,22.1 36.1,23 35,23 L3,23 C1.9,23 1,22.1 1,21 L1,3 C1,1.9 1.9,1 3,1 L35,1"></path><path fill="#FFF" d="M8.971,10.268 L9.745,12.144 L8.203,12.144 L8.971,10.268 Z M25.046,10.346 L22.069,10.346 L22.069,11.173 L24.998,11.173 L24.998,12.412 L22.075,12.412 L22.075,13.334 L25.052,13.334 L25.052,14.073 L27.129,11.828 L25.052,9.488 L25.046,10.346 L25.046,10.346 Z M10.983,8.006 L14.978,8.006 L15.865,9.941 L16.687,8 L27.057,8 L28.135,9.19 L29.25,8 L34.013,8 L30.494,11.852 L33.977,15.68 L29.143,15.68 L28.065,14.49 L26.94,15.68 L10.03,15.68 L9.536,14.49 L8.406,14.49 L7.911,15.68 L4,15.68 L7.286,8 L10.716,8 L10.983,8.006 Z M19.646,9.084 L17.407,9.084 L15.907,12.62 L14.282,9.084 L12.06,9.084 L12.06,13.894 L10,9.084 L8.007,9.084 L5.625,14.596 L7.18,14.596 L7.674,13.406 L10.27,13.406 L10.764,14.596 L13.484,14.596 L13.484,10.661 L15.235,14.602 L16.425,14.602 L18.165,10.673 L18.165,14.603 L19.623,14.603 L19.647,9.083 L19.646,9.084 Z M28.986,11.852 L31.517,9.084 L29.695,9.084 L28.094,10.81 L26.546,9.084 L20.652,9.084 L20.652,14.602 L26.462,14.602 L28.076,12.864 L29.624,14.602 L31.499,14.602 L28.987,11.852 L28.986,11.852 Z"></path></g></svg>

            
          </div></div>`);
    $('.footer-bottom').before(nuevoDiv);


    $('.footer-bottom > div > span:first-child').html('© Sicurezza 2023 - Sicurezza CO SAC - RUC N° 20600261151');
    if ($(window).width() < 991) { 
        $("mobile-navigation nav").append('<a href="/cart" style="display:flex;"><div class="carrito_movil"><p>Carrito</p> <span></span></div></a>');
        var titulo_producto = $(".product__title").clone();
        var ranking = $(".star-rating").clone();
        var precio = $(".precio_producto").clone();
        var nuevoDiv = $("<div class='div_contenido_movil'></div>");
        nuevoDiv.append(titulo_producto,  precio , ranking);
        $(".product-gallery").prepend(nuevoDiv);

        $('.product-text h1').remove();
        $('.product-text .star-rating').remove();
        $('.product-text .precio_producto').remove();
    }

let item_productos = $('.seccion_productos h2');
let div_productos = $('<div class="tabs_productos container--large"></div>');
$('.seccion_productos.tops-bras').before( div_productos);
item_productos.each(function(index){
    let itemsProducto = $(this).text();
    let titleProducto = $(this).attr('data-title-producto');
    let nuevoDiv = $('<div class="" data-item="' + itemsProducto + '"><div>' +  titleProducto + '</div></div>');
    div_productos.append(nuevoDiv);
})
 $('.seccion_productos.tops-bras').addClass('activado');
  $('.tabs_productos div[data-item="tops-bras"]').addClass('activado');
  
    $('.tabs_productos > div').click(function(){
    var producto_select = $(this).attr('data-item');
     $('.tabs_productos div').removeClass('activado');
    $('.seccion_productos').removeClass('activado');
     $(this).addClass('activado');
    $('.all_products_inp[data-producto="'+ producto_select +'"]').closest('.seccion_productos').addClass('activado');
  })

  
let item_tiendas = $('.seccion_tiendas h2');
let div_tiendas = $('<div class="tabs_tiendas container--large"></div>')
$('.seccion_tiendas.tiendas').before(div_tiendas);
item_tiendas.each(function(index){
    let itemsTienda = $(this).text();
    let nuevoDiv = $('<div class="" data-item="' + itemsTienda + '"><div>' + itemsTienda + '</div></div>');
    div_tiendas.append(nuevoDiv);
})
  $('.all_tiendas[data-tienda="Tiendas"]').closest('.seccion_tiendas').addClass('activado');
  $('.tabs_tiendas div[data-item="Tiendas"]').addClass('activado');
  
  $('.tabs_tiendas > div').click(function(){
    var tienda_select = $(this).attr('data-item');
     $('.tabs_tiendas div').removeClass('activado');
    $('.all_tiendas').closest('.seccion_tiendas').removeClass('activado');
     $(this).addClass('activado');
    $('.all_tiendas[data-tienda="'+ tienda_select +'"]').closest('.seccion_tiendas').addClass('activado');
  })



  
    $('.carrousel-texto').slick({
    
      autoplay:true,
   autoplaySpeed: 4000,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1

  });
$('.seccion_img_marcas').slick({
  slidesToShow: 4,
  slidesToScroll: 4,
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    }
  ]
});

  $('.btn_modal_inp').click(function(){
      $('.seccion_modal_inp').toggleClass('activado');
      $('.fondo_modal').toggleClass('activado');
     
  })

  $('.fondo_modal').click(function(){
     $('.seccion_modal_inp').removeClass('activado');
      $('.fondo_modal').removeClass('activado');
      
  })
    $('.btn_cerrar_modal').click(function(){
     $('.seccion_modal_inp').removeClass('activado');
      $('.fondo_modal').removeClass('activado');
    
  })
  $('.seccion_modal_inp .titulo_navbs > div').click(function(){
    $('.seccion_modal_inp .titulo_navbs > div').removeClass('activado');
    $(this).addClass('activado');
    var numbtitulo = $(this).attr('count-numb');
     $('.seccion_modal_inp .contenido div[count-numb]').removeClass('activado');
    $('.seccion_modal_inp .contenido div[count-numb=' + numbtitulo + ']').toggleClass('activado');
  })

  
$(document).ready(function() {
  function radioActivo1() {
    var selectedValue = $('.cheak_pc_block1 input[name=pc_block1]:checked').val();
      var selectedValue2 = $('.cheak_pc_block2 input[name=pc_block2]:checked').val();
    if(selectedValue == 'Pulgadas'){
      $('.img_pulgadas').removeClass('ocultar');
      $('.img_centimetros').addClass('ocultar');
    }else{
      $('.img_pulgadas').addClass('ocultar');
        $('.img_centimetros').removeClass('ocultar');
    }

  }

   function radioActivo2() {
   
      var selectedValue2 = $('.cheak_pc_block2 input[name=pc_block2]:checked').val();
    if(selectedValue2 == 'Pulgadas'){
      $('.img_pulgadas').removeClass('ocultar');
      $('.img_centimetros').addClass('ocultar');
    }else{
      $('.img_pulgadas').addClass('ocultar');
        $('.img_centimetros').removeClass('ocultar');
    }

  }
  radioActivo1();
  radioActivo2()

  $('.cheak_pc_block1 input[name=pc_block1]').on('change', radioActivo1);
$('.cheak_pc_block2 input[name=pc_block2]').on('change', radioActivo2);
  $('.guia_medir h4').click(function(){
    $(this).closest('.guia_medir').toggleClass('activado');
  })

  
  var clonedDiv = $('.btn_modal_inp').clone();
   clonedDiv.prependTo('.product-actions');
  $('.product-actions .btn_modal_inp').click(function(){
    $('.activa_modal .btn_modal_inp').click();
  })
});

// 

  $('.seccion_coleccion_producto').slick({
  dots: true,
  autoplay: true,
  autoplaySpeed: 2000,
  infinite: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 4,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }

  ]
});
  
});